import { render } from "./ReadyPopcornSlider.vue?vue&type=template&id=639cfdcb&scoped=true"
import script from "./ReadyPopcornSlider.vue?vue&type=script&lang=js"
export * from "./ReadyPopcornSlider.vue?vue&type=script&lang=js"

import "./ReadyPopcornSlider.vue?vue&type=style&index=0&id=639cfdcb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639cfdcb"]])

export default __exports__